import React, { useState, useMemo, useEffect, useRef } from 'react';
import { apiHolder, apis } from 'api';
import MailDiscussPopover from '../MailDiscussPopover/mailDiscussPopover';
import useDebounceForEvent from '@web-mail/hooks/useDebounceForEvent';
import { Modal } from 'antd';
import { getIn18Text } from 'api';
const discussApi = apiHolder.api.requireLogicalApi(apis.imDiscussApiImpl);
const trackApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const sysApi = apiHolder.api.getSystemApi();
const nimApi = apiHolder.api.requireLogicalApi('NIM');
const MailDiscussModal = props => {
    const { keyIds, visiable = false, onClosed } = props;
    const popoverRef = useRef(null);
    const [teamMsgs, setTeamMsgs] = useState({
        ownTeams: [],
        joinTeams: [],
    });
    const midRef = useRef('');
    const isMounted = useRef(false);
    const teamCount = useMemo(() => {
        const { ownTeams, joinTeams } = teamMsgs;
        return ownTeams.length + joinTeams.length;
    }, [teamMsgs]);
    const resetTeamMsgs = () => {
        setTeamMsgs({
            ownTeams: [],
            joinTeams: [],
        });
    };
    const getMailDiscuss = async () => {
        var _a;
        midRef.current = keyIds === null || keyIds === void 0 ? void 0 : keyIds.mid;
        const currentUser = sysApi.getCurrentUser();
        const contactInfo = (_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.contact) === null || _a === void 0 ? void 0 : _a.contactInfo;
        if (!contactInfo) {
            return;
        }
        const yunxinInfo = contactInfo.find(item => item.contactItemType === 'yunxin');
        if (!yunxinInfo) {
            return;
        }
        try {
            const { contactItemVal: yxAccId } = yunxinInfo;
            const res = await discussApi.getMailDiscuss({
                yxAccId,
                emailTid: (keyIds === null || keyIds === void 0 ? void 0 : keyIds.tid) || '',
                emailMid: (keyIds === null || keyIds === void 0 ? void 0 : keyIds.mid) || '',
            });
            if (!isMounted.current) {
                console.warn('mailDiscuss done component unmounted');
                return;
            }
            if (res.code === 0) {
                if (midRef.current === (keyIds === null || keyIds === void 0 ? void 0 : keyIds.mid)) {
                    const { ownTeams, joinTeams } = res === null || res === void 0 ? void 0 : res.data;
                    setTeamMsgs({ ownTeams: ownTeams || [], joinTeams: joinTeams || [] });
                }
                else {
                    console.warn('mailDiscuss id 不一致');
                }
            }
            else {
                console.warn(getIn18Text('JIEKOUHUOQUYOU'), res.message);
            }
        }
        catch (error) {
            console.error(getIn18Text('HUOQUYOUJIANTAO'), error);
        }
    };
    const debounceGetMailDiscuss = useDebounceForEvent(() => {
        getMailDiscuss();
    }, 600, { leading: false });
    useEffect(() => {
        if (visiable) {
            trackApi.track('pcmail_hover_mailDetail_mailChatButton', {});
            debounceGetMailDiscuss();
        }
        else {
            setTeamMsgs({
                ownTeams: [],
                joinTeams: [],
            });
        }
    }, [visiable]);
    useEffect(() => {
        isMounted.current = true;
        if (keyIds === null || keyIds === void 0 ? void 0 : keyIds.mid) {
            debounceGetMailDiscuss();
        }
        else {
            resetTeamMsgs();
        }
        return () => {
            isMounted.current = false;
        };
    }, [keyIds === null || keyIds === void 0 ? void 0 : keyIds.mid]);
    if (teamCount === 0 && !nimApi.getIMAuthConfig()) {
        return null;
    }
    const handleClose = () => {
        onClosed && onClosed();
    };
    return (React.createElement(Modal, { visible: visiable, onOk: handleClose, onCancel: handleClose, footer: null },
        React.createElement(MailDiscussPopover, { mailMid: keyIds === null || keyIds === void 0 ? void 0 : keyIds.mid, teamMsgs: teamMsgs, teamCount: teamCount, closePopover: handleClose, noWrap: true })));
};
export default MailDiscussModal;
